// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.searchBoxContainer {
  display: flex;
  align-items: center;
  box-sizing: border-box;
}
.searchBoxContainer.searchBoxContainer--fullWidth {
  width: 100%;
}
.searchBoxContainer.searchBoxContainer--fullWidth .searchBox {
  width: 100% !important;
}
.searchBoxContainer .searchBox {
  border-radius: 10px;
  padding: 4px 14px !important;
  background: #f8fafc;
  border: 1px solid #e6e9f0;
  outline: none;
  color: #64748b;
  font-size: 14px;
  height: 40px;
  font-weight: 500;
  box-sizing: border-box;
  width: 345px;
  transition: border-color 200ms ease, box-shadow 200ms ease, background 200ms ease;
}
.searchBoxContainer .searchBox input {
  color: #1e293b;
  background: transparent;
}
.searchBoxContainer .searchBox .ant-input::placeholder {
  color: #94a3b8;
}
.searchBoxContainer .searchBox:focus {
  border-color: #004195 !important;
  z-index: 5;
}
.searchBoxContainer .searchBox:focus-within {
  border-color: #004195;
  background: #ffffff;
  box-shadow: 0 0 0 3px rgba(0, 65, 149, 0.12);
}
.searchBoxContainer .searchBox:hover {
  border-color: rgba(0, 65, 149, 0.4);
  background: #ffffff;
}
.searchBoxContainer .searchBox .searchOutline {
  color: #64748b;
  transition: color 200ms ease;
}
.searchBoxContainer .searchBox .searchOutline svg {
  font-size: 16px;
}
.searchBoxContainer .searchBox:focus-within .searchOutline {
  color: #004195;
}

::placeholder {
  color: #94a3b8;
}

:-ms-input-placeholder {
  color: #94a3b8;
}

::-ms-input-placeholder {
  color: #94a3b8;
}`, "",{"version":3,"sources":["webpack://./src/components/Search/search.scss"],"names":[],"mappings":"AAOA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;AANF;AAQE;EACE,WAAA;AANJ;AAQI;EACE,sBAAA;AANN;AAUE;EACE,mBAAA;EACA,4BAAA;EACA,mBArBe;EAsBf,yBAAA;EACA,aAAA;EACA,cA1BS;EA2BT,eAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,YAAA;EACA,iFACE;AATN;AAaI;EACE,cAAA;EACA,uBAAA;AAXN;AAcI;EACE,cA1Cc;AA8BpB;AAeI;EACE,gCAAA;EACA,UAAA;AAbN;AAgBI;EACE,qBAhDS;EAiDT,mBAAA;EACA,4CAAA;AAdN;AAiBI;EACE,mCAAA;EACA,mBAAA;AAfN;AAkBI;EACE,cA/DO;EAgEP,4BAAA;AAhBN;AAkBM;EACE,eAAA;AAhBR;AAoBI;EACE,cApES;AAkDf;;AAuBA;EACE,cA7EkB;AAyDpB;;AAuBA;EACE,cAjFkB;AA6DpB;;AAuBA;EACE,cArFkB;AAiEpB","sourcesContent":["$text_color: #64748b;\n$placeholder_color: #94a3b8;\n$background_color: #f8fafc;\n$border_color: #e6e9f0;\n$colorPrimary: #004195;\n$colorPrimarySoft: rgba(0, 65, 149, 0.12);\n\n.searchBoxContainer {\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n\n  &.searchBoxContainer--fullWidth {\n    width: 100%;\n\n    .searchBox {\n      width: 100% !important;\n    }\n  }\n\n  .searchBox {\n    border-radius: 10px;\n    padding: 4px 14px !important;\n    background: $background_color;\n    border: 1px solid $border_color;\n    outline: none;\n    color: $text_color;\n    font-size: 14px;\n    height: 40px;\n    font-weight: 500;\n    box-sizing: border-box;\n    width: 345px;\n    transition:\n      border-color 200ms ease,\n      box-shadow 200ms ease,\n      background 200ms ease;\n\n    input {\n      color: #1e293b;\n      background: transparent;\n    }\n\n    .ant-input::placeholder {\n      color: $placeholder_color;\n    }\n\n    &:focus {\n      border-color: $colorPrimary !important;\n      z-index: 5;\n    }\n\n    &:focus-within {\n      border-color: $colorPrimary;\n      background: #ffffff;\n      box-shadow: 0 0 0 3px $colorPrimarySoft;\n    }\n\n    &:hover {\n      border-color: rgba(0, 65, 149, 0.4);\n      background: #ffffff;\n    }\n\n    .searchOutline {\n      color: $text_color;\n      transition: color 200ms ease;\n\n      svg {\n        font-size: 16px;\n      }\n    }\n\n    &:focus-within .searchOutline {\n      color: $colorPrimary;\n    }\n  }\n}\n\n::placeholder {\n  color: $placeholder_color;\n}\n\n:-ms-input-placeholder {\n  color: $placeholder_color;\n}\n\n::-ms-input-placeholder {\n  color: $placeholder_color;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
